// Área PROXYS.
// KPIs, busca, célula combinada host:porta:usuario:senha editável (re-divide nos
// 4 campos ao salvar), select de status, add/del — ligados ao Supabase.
import { kpiHTML, debounce } from './shared.js'
import { esc, svgDel, svgCopy } from '../lib/format.js'
import { marcarSujo, marcarLimpo } from '../lib/save-status.js'
import { state, posicaoTopo } from '../store.js'
import { proxysRepo } from '../data/repositories.js'

const STATUS_OPTS = ['Ativa', 'Inativa', 'Caiu']
let proxysSearch = ''

let toast = () => {}
export function setToast(fn) {
  toast = fn
}

// Recompõe a string "host:porta:usuario:senha" preservando as POSIÇÕES (sem
// filtrar vazios), para que editar→re-dividir seja simétrico e não desalinhe
// os campos. Se os 4 estiverem vazios, mostra string vazia.
function enderecoStr(p) {
  const parts = [p.host, p.porta, p.usuario, p.senha]
  if (parts.every(v => String(v ?? '').trim() === '')) return ''
  return parts.join(':')
}

// Divide a string "host:porta:usuario:senha" de volta nos 4 campos.
function aplicarEndereco(p, str) {
  const parts = String(str).split(':')
  p.host = parts[0] ?? ''
  p.porta = parts[1] ?? ''
  p.usuario = parts[2] ?? ''
  p.senha = parts[3] ?? ''
}

async function persistirEndereco(p) {
  if (!p.id) return
  try {
    await proxysRepo.update(p.id, {
      host: p.host || '',
      porta: p.porta || '',
      usuario: p.usuario || '',
      senha: p.senha || ''
    })
  } catch (e) {
    toast('Erro ao salvar', true)
  }
}

async function persistirCampo(p, campo) {
  if (!p.id) return
  try {
    await proxysRepo.update(p.id, { [campo]: p[campo] || '' })
  } catch (e) {
    toast('Erro ao salvar', true)
  }
}

export function renderProxys() {
  const d = state.proxys
  const ativ = d.filter(p => (p.status || '').toLowerCase() === 'ativa').length
  const gest = {}
  d.forEach(p => {
    const g = (p.gestor || '').trim()
    if (g) gest[g] = (gest[g] || 0) + 1
  })
  document.getElementById('proxysKpis').innerHTML =
    kpiHTML('Total', d.length, '', '') +
    kpiHTML('Ativos', ativ, '', '') +
    kpiHTML('Gestores', Object.keys(gest).length, '', 'b')

  const body = document.getElementById('proxysBody')
  body.innerHTML = ''
  const term = proxysSearch.toLowerCase()
  let shown = 0

  d.forEach(p => {
    if (term) {
      const hay = [p.nome, enderecoStr(p), p.gestor, p.status].join(' ').toLowerCase()
      if (!hay.includes(term)) return
    }
    shown++
    const tr = document.createElement('tr')

    // Coluna 1: nome do proxy (texto).
    const tdNome = document.createElement('td')
    const inpNome = document.createElement('input')
    inpNome.className = 'cell'
    inpNome.value = p.nome ?? ''
    const salvarNome = debounce(async () => {
      const snap = inpNome.value
      await persistirCampo(p, 'nome')
      if (inpNome.value === snap) marcarLimpo(inpNome)
    })
    inpNome.oninput = () => {
      p.nome = inpNome.value
      marcarSujo(inpNome)
      salvarNome()
    }
    inpNome.onblur = () => salvarNome.flush()
    tdNome.appendChild(inpNome)
    tr.appendChild(tdNome)

    // Coluna 2: endereço combinado (mono) + botão copiar.
    const tdEnd = document.createElement('td')
    tdEnd.style.whiteSpace = 'nowrap'
    const inpEnd = document.createElement('input')
    inpEnd.className = 'cell mono'
    inpEnd.value = enderecoStr(p)
    const salvarEnd = debounce(async () => {
      const snap = inpEnd.value
      await persistirEndereco(p)
      if (inpEnd.value === snap) marcarLimpo(inpEnd)
    })
    inpEnd.oninput = () => {
      aplicarEndereco(p, inpEnd.value)
      marcarSujo(inpEnd)
      salvarEnd()
    }
    inpEnd.onblur = () => salvarEnd.flush()
    tdEnd.appendChild(inpEnd)
    const cp = document.createElement('span')
    cp.className = 'copy'
    cp.innerHTML = svgCopy
    cp.title = 'Copiar'
    cp.onclick = () => {
      if (navigator.clipboard) navigator.clipboard.writeText(enderecoStr(p))
      toast('Copiado')
    }
    tdEnd.appendChild(cp)
    tr.appendChild(tdEnd)

    // Coluna 3: gestor (texto).
    const tdGest = document.createElement('td')
    const inpGest = document.createElement('input')
    inpGest.className = 'cell'
    inpGest.value = p.gestor ?? ''
    const salvarGest = debounce(async () => {
      const snap = inpGest.value
      await persistirCampo(p, 'gestor')
      if (inpGest.value === snap) marcarLimpo(inpGest)
    })
    inpGest.oninput = () => {
      p.gestor = inpGest.value
      marcarSujo(inpGest)
      salvarGest()
    }
    inpGest.onblur = () => salvarGest.flush()
    tdGest.appendChild(inpGest)
    tr.appendChild(tdGest)

    // Coluna 4: status — a própria pílula abre o dropdown (select sobreposto).
    const tdSt = document.createElement('td')
    const v = p.status || ''
    const wrap = document.createElement('span')
    wrap.className = 'st-wrap'
    const span = document.createElement('span')
    span.className = 'st ' + v.replace(/\s+/g, '')
    span.innerHTML = esc(v || '—') + '<span class="st-caret">▾</span>'
    const sel = document.createElement('select')
    const list = STATUS_OPTS.includes(v) ? STATUS_OPTS : v ? [v, ...STATUS_OPTS] : STATUS_OPTS
    list.forEach(o => {
      const op = document.createElement('option')
      op.value = o
      op.textContent = o || '—'
      if (v === o) op.selected = true
      sel.appendChild(op)
    })
    sel.onchange = async () => {
      p.status = sel.value
      await persistirCampo(p, 'status')
      renderProxys()
    }
    wrap.appendChild(span)
    wrap.appendChild(sel)
    tdSt.appendChild(wrap)
    tr.appendChild(tdSt)

    // Coluna 5: excluir.
    const tdD = document.createElement('td')
    const del = document.createElement('span')
    del.className = 'del'
    del.innerHTML = svgDel
    del.onclick = async () => {
      const i = state.proxys.indexOf(p)
      if (i === -1) return
      state.proxys.splice(i, 1)
      renderProxys()
      try {
        if (p.id) await proxysRepo.remove(p.id)
      } catch (e) {
        state.proxys.splice(i, 0, p) // rollback: o banco não confirmou
        renderProxys()
        toast('Erro ao excluir', true)
      }
    }
    tdD.appendChild(del)
    tr.appendChild(tdD)

    body.appendChild(tr)
  })

  const c = document.getElementById('proxysCount')
  if (c) c.textContent = shown + (shown !== d.length ? ' / ' + d.length : '') + ' linhas'
}

export function ligarProxys() {
  document.getElementById('proxysSearch').oninput = e => {
    proxysSearch = e.target.value
    renderProxys()
  }
  document.getElementById('addProxy').onclick = async () => {
    const novo = {
      id: crypto.randomUUID(),
      nome: '',
      host: '',
      porta: '',
      usuario: '',
      senha: '',
      gestor: '',
      status: 'Ativa',
      posicao: posicaoTopo(state.proxys)
    }
    state.proxys.unshift(novo)
    renderProxys()
    try {
      const salvo = await proxysRepo.insert(novo)
      novo.id = salvo.id
      toast('Proxy adicionado')
    } catch (e) {
      const i = state.proxys.indexOf(novo) // rollback: insert falhou
      if (i !== -1) state.proxys.splice(i, 1)
      renderProxys()
      toast('Erro ao salvar — proxy não criado', true)
    }
  }
}

export function onExternalChange() {
  renderProxys()
}
